export const ACCESS_PAGES_REQUEST = "ACCESS_PAGES_REQUEST";
export const ACCESS_PAGES_SUCCESS = "ACCESS_PAGES_SUCCESS";
export const ACCESS_PAGES_FAIL = "ACCESS_PAGES_FAIL";
